import { Editor } from 'grapesjs';
import { facOneColumn } from '@qualifio/ui-commons';
import { EditorComponentDefinition } from '../types';
import { Toolbar } from '../../utils';

export const oneColumnComponentDefinition: EditorComponentDefinition = {
  id: 'oneColumn',
  icon: facOneColumn,
  category: 'Basic',
  getLabel: ({ t }) => t('editor.component.one-column'),
  component: OneColumnComponent,
};

export function OneColumnComponent(editor: Editor) {
  const CLASSNAME = 'qlfeditor-columns';

  editor.DomComponents.addType(oneColumnComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains(`${CLASSNAME}--1column`);
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'Basic',
        components: [
          {
            type: 'column',
            removable: false,
            copyable: false,
            draggable: false,
            selectable: true,
            hoverable: false,
          },
        ],
        attributes: {
          class: `${CLASSNAME} ${CLASSNAME}--1column`,
        },
        droppable: false,
        draggable: '[data-gjs-type=wrapper], [data-gjs-type=column]',
        traits: [],
      },
      initToolbar: Toolbar,
    },
  });
}
